var React = require('react');

function CircleArrow (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"25","cy":"25","r":"24.5","stroke":"#333333","key":0}),React.createElement("path",{"d":"M25.9167 18L24.9037 18.9751L30.2729 24.3H16V25.7H30.2729L24.9037 31.0011L25.9167 32L33 25L25.9167 18Z","fill":"#333333","key":1})]);
}

CircleArrow.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none"};

module.exports = CircleArrow;

CircleArrow.default = CircleArrow;
